import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {formatAbn} from '../../../utils/formatter'
import {
  SectionContainer,
  SectionTitle,
  SectionDivider,
} from '../../components/Section'
import {
  SubsectionTitle,
  SubsectionSubtitle,
  SubsectionGroup,
  SubsectionContainer,
} from '../../components/Subsection'
import {CustomerRatingSection} from './CustomerRatingSection'

const Row = ({children}) => (
  <Flex direction={{base: 'column', md: 'row'}} gap="sm">
    {children}
  </Flex>
)

Row.propTypes = {
  children: PropTypes.node.isRequired,
}

const RowItemLeft = ({children}) => (
  <Box flex={{base: '1 0 0', md: '0 0 350px'}}>{children}</Box>
)

RowItemLeft.propTypes = {
  children: PropTypes.node.isRequired,
}

const RowItemRight = ({children}) => <Box flex="1 0 0">{children}</Box>

RowItemRight.propTypes = {
  children: PropTypes.node.isRequired,
}
export const CustomerDetails = ({customer}) => {
  const {t} = useTranslation('customers')

  return (
    <SectionContainer data-testid="customer-details">
      <SectionTitle text={t('CustomerDetails.title')} />
      <SectionDivider />
      <SubsectionContainer className="fs-mask">
        <Row>
          <RowItemLeft>
            <SubsectionGroup>
              <SubsectionTitle title={t('CustomerDetails.name')} />
              <SubsectionSubtitle>{[customer.firstName, customer.lastName].filter(Boolean).join(' ')}</SubsectionSubtitle>
            </SubsectionGroup>
          </RowItemLeft>

          <RowItemRight>
            <CustomerRatingSection
              score={customer.customerRating.score}
              topReason={customer.customerRating.topReason.key}
            />
          </RowItemRight>
        </Row>

        <Row>
          <RowItemLeft>
            <SubsectionGroup>
              <SubsectionTitle title={t('CustomerDetails.emailAddress')} />
              <SubsectionSubtitle>{customer.email}</SubsectionSubtitle>
            </SubsectionGroup>
          </RowItemLeft>

          <RowItemRight>
            <SubsectionGroup>
              <SubsectionTitle title={t('CustomerDetails.phoneNumber')} />
              <SubsectionSubtitle>{customer.phone}</SubsectionSubtitle>
            </SubsectionGroup>
          </RowItemRight>
        </Row>

        <Row>
          <RowItemLeft>
            <SubsectionGroup>
              <SubsectionTitle title={t('CustomerDetails.businessNumber')} />
              <SubsectionSubtitle>{formatAbn(customer.abn)}</SubsectionSubtitle>
            </SubsectionGroup>
          </RowItemLeft>

          {customer.billingAddress && (
            <RowItemRight>
              <SubsectionGroup>
                <SubsectionTitle title={t('CustomerDetails.billingAddress')} />
                <SubsectionSubtitle>
                  {customer.billingAddress}
                </SubsectionSubtitle>
              </SubsectionGroup>
            </RowItemRight>
          )}
        </Row>
      </SubsectionContainer>
    </SectionContainer>
  )
}

CustomerDetails.propTypes = {
  customer: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    abn: PropTypes.string,
    billingAddress: PropTypes.string,
    contactName: PropTypes.string,
    customerRating: PropTypes.shape({
      score: PropTypes.number,
      topReason: PropTypes.shape({
        key: PropTypes.string.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        values: PropTypes.object,
      }).isRequired,
    }).isRequired,
  }).isRequired,
}

export default CustomerDetails
